<script>
export default {
  props: ["title", "dataSource"],
  emits: ["click-item"],
};
</script>

<template>
  <div :class="`${$style.part}`">
    <div :class="`${$style.placeBox}`">
      <h2 :class="$style.title">{{ title }}</h2>
      <div v-if="dataSource.length > 0" :class="$style.gameList">
        <div
          v-for="game in dataSource"
          :key="game.gameId"
          :class="$style.gameBox"
          @click="$emit('click-item', { ...game, isMore: title==='在玩游戏会场'? 1 : 2 })"
        >
          <img :src="game.logo" alt="游戏图片" :class="$style.gameImg" />
          <div :class="$style.gameSection">
            <div :class="$style.gameTitle">{{ game.appName }}</div>
            <div :class="$style.gameDesc">{{ game.giftValue }}元礼包</div>
          </div>
        </div>
      </div>
      <div v-else :class="$style.empty">
        <slot name="empty"></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.part {
  width: 94%;
  margin: 0 auto 20px;
  box-shadow: 2px 2px 3px rgb(185 31 8 / 64%);
  background: #FFB369;
  border-radius: 4px;
  padding: 3px;
  .placeBox{
    background: #fff;
    padding: 11.34px 10.36px 10.65px;
    border-radius: 2px;
  }
  .title {
    font-size: 18px;
    font-weight: 700;
    text-align: left;
    line-height: 20px;
    margin-bottom: 10px;
    color: #ffb017;
  }
  .empty {
    color: #666666;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    > p {
      line-height: 24px;
    }
  }
  .gameList {
    display: flex;
    flex-wrap: wrap;
  }
  .gameBox {
    width: 47%;
    display: flex;
    justify-content: left;
    align-items: center;
    margin-bottom: 6px;
    margin-left: 9px;
    .gameImg {
      width: 45px;
      height: 45px;
      margin-right: 5px;
    }
    .gameTitle {
      font-size: 14px;
      font-weight: 500;
      text-align: left;
      color: #666666;
      line-height: 15px;
    }
    .gameDesc {
      font-size: 12px;
      font-weight: 500;
      text-align: left;
      color: #ffb017;
      line-height: 12px;
      margin-top: 9px;
    }
  }
}
</style>
